/**
 * @desc 根据sku编码获取sku列表成品
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmBomListResponseDto>>;
export function request(skuNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/getSku/${skuNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
